/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MatchOperationsMode {
    ResultOnly = 'RESULT_ONLY',
    LiveMatchOperations = 'LIVE_MATCH_OPERATIONS'
}


export function instanceOfMatchOperationsMode(value: any): boolean {
    for (const key in MatchOperationsMode) {
        if (Object.prototype.hasOwnProperty.call(MatchOperationsMode, key)) {
            if (MatchOperationsMode[key as keyof typeof MatchOperationsMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MatchOperationsModeFromJSON(json: any): MatchOperationsMode {
    return MatchOperationsModeFromJSONTyped(json, false);
}

export function MatchOperationsModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationsMode {
    return json as MatchOperationsMode;
}

export function MatchOperationsModeToJSON(value?: MatchOperationsMode | null): any {
    return value as any;
}

export function MatchOperationsModeToJSONTyped(value: any, ignoreDiscriminator: boolean): MatchOperationsMode {
    return value as MatchOperationsMode;
}

